{
  "title": "Sickening Radiance",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "4th-level evocation",
  "level": 4,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Dim, greenish light spreads within a 30-foot-radius sphere centered on a point you choose within range. The light spreads around corners, and it lasts until the spell ends.",
    "When a creature moves into the spell’s area for the first time on a turn or starts its turn there, that creature must succeed on a Constitution saving throw or take 4d10 radiant damage, and it suffers one level of exhaustion and emits a dim, greenish light in a 5-foot radius. This light makes it impossible for the creature to benefit from being invisible. The light and any levels of exhaustion caused by this spell go away when the spell ends."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
